import { useParams } from "react-router-dom";

import Button from "../../../../components/Button";
import Choice from "./Choice";
import Question from "./Question";
import usePermission from "../../../../hooks/usePermission";

function QuestionView({ question }) {
  const { can } = usePermission();

  const { courseId, lectureId, itemId } = useParams();
  return (
    <>
      <Question question={question?.question} image={question.image} />
      <div className="grid w-full gap-6 py-5 md:grid-cols-2">
        {question?.options?.map((option, index) => (
          <Choice key={option.id} choice={option} optionNum={index} />
        ))}
      </div>
      {can("read:course:lecture:quiz:quiestion:options") && (
        <div className="w-full pt-3">
          <Button
            type="primary"
            className="w-full leading-8 text-center"
            to={`/admin/courses/${courseId}/lectures/${lectureId}/items/${itemId}/questions/${question.id}/options`}
          >
            الدخول للسؤال
          </Button>
        </div>
      )}
    </>
  );
}

export default QuestionView;
